export const DEFAULT_LOCALE = 'en-GB';

export const LOCALES = ['en-GB'];
